import { Dispatch, SetStateAction } from "react";
import { useTranslations } from "next-intl";

interface IHumburgerMenu {
  isMenuOpen: boolean;
  setIsMenuOpen: Dispatch<SetStateAction<boolean>>;
}

const HumburgerMenu = ({ isMenuOpen, setIsMenuOpen }: IHumburgerMenu) => {
  const t = useTranslations("HumburgerMenu");
  return (
    <button
      className="lg:hidden flex flex-col justify-around w-6 h-6 cursor-pointer"
      onClick={() => setIsMenuOpen(!isMenuOpen)}
      aria-label={t("ariaLabel")}
    >
      <span
        className={`w-full h-0.5 bg-text-primary transition-all rounded-[1px] ${
          isMenuOpen ? "rotate-45 translate-y-2" : ""
        }`}
      />
      <span
        className={`w-full h-0.5 bg-text-primary transition-all rounded-[1px] ${
          isMenuOpen ? "opacity-0" : ""
        }`}
      />
      <span
        className={`w-full h-0.5 bg-text-primary transition-all rounded-[1px] ${
          isMenuOpen ? "-rotate-45 -translate-y-2" : ""
        }`}
      />
    </button>
  );
};

export default HumburgerMenu;
